
export enum TicketState {
  Open = "Open",
  Closed = "Closed"
}
